import { Tooltip } from "@mui/material";
import { useMemo, useState } from "react";

import { Button } from "@/components/atoms/Button/styles";
import { StyledDataTable } from "@/components/molecules/StyledDataTable";

import { CallPlanInfoFragment } from "../../../../graphql/graphql";
import { PlaylistTableWrapper, RightHeaderDiv, RightStyledH1 } from "../../styles";
import { buildCallPlanColumns, duplicateProgramWeekEarlierPlanIds } from "./columns";
import CreateCallPlanModal from "./CreateCallPlanModal";
import {
  CREATE_CALL_PLAN_DISABLED_PROGRAM_ENDED_MESSAGE,
  isCreateCallPlanBlockedByProgramEnd,
} from "./CreateCallPlanModal/CreateCallPlanModal.utils";

type CallPlansProps = {
  accountId: number;
  callPlans: CallPlanInfoFragment[];
};

const CallPlans: React.FC<CallPlansProps> = ({ accountId, callPlans }) => {
  const [createCallPlanModalOpen, setCreateCallPlanModalOpen] = useState(false);
  const [callPlanToEdit, setCallPlanToEdit] = useState<CallPlanInfoFragment | null>(null);

  const closeCreateCallPlanModal = () => {
    setCreateCallPlanModalOpen(false);
    setCallPlanToEdit(null);
  };

  const duplicateWeekEarlierPlanIds = useMemo(
    () => duplicateProgramWeekEarlierPlanIds(callPlans),
    [callPlans]
  );

  const createBlockedByProgramEnd = useMemo(
    () => isCreateCallPlanBlockedByProgramEnd(callPlans),
    [callPlans]
  );

  const tableColumns = useMemo(
    () =>
      buildCallPlanColumns(
        (row) => {
          setCallPlanToEdit(row);
          setCreateCallPlanModalOpen(true);
        },
        duplicateWeekEarlierPlanIds,
        createBlockedByProgramEnd
      ),
    [createBlockedByProgramEnd, duplicateWeekEarlierPlanIds]
  );

  return (
    <>
      <RightHeaderDiv>
        <RightStyledH1>
          Call Plans
          <Tooltip
            title={createBlockedByProgramEnd ? CREATE_CALL_PLAN_DISABLED_PROGRAM_ENDED_MESSAGE : ""}
          >
            <span>
              <Button
                disabled={createBlockedByProgramEnd}
                onClick={() => {
                  setCallPlanToEdit(null);
                  setCreateCallPlanModalOpen(true);
                }}
              >
                Create New Call Plan
              </Button>
            </span>
          </Tooltip>
        </RightStyledH1>
      </RightHeaderDiv>
      <PlaylistTableWrapper>
        <StyledDataTable
          columns={tableColumns}
          data={callPlans}
          defaultSortFieldId="dateRange"
          defaultSortAsc={false}
        />
      </PlaylistTableWrapper>
      <CreateCallPlanModal
        accountId={accountId}
        callPlans={callPlans}
        callPlanToEdit={callPlanToEdit}
        open={createCallPlanModalOpen}
        onClose={closeCreateCallPlanModal}
      />
    </>
  );
};

export default CallPlans;
